// extracted by mini-css-extract-plugin
module.exports = {"tabsWrapper":"styles_tabsWrapper__1KODT","tab":"styles_tab__3C2PD","activeTab":"styles_activeTab__rZ92h","slideInFromRight":"styles_slideInFromRight__2POy7"};